import { useQuery } from '@tanstack/react-query'
import { baseClient } from 'builder/modules/apiClient'
import { TemplateCategories, TemplateCategory } from 'builder/modules/resumeEditor'

export type TemplateCategoriesType = Record<`${TemplateCategories}`, TemplateCategory>
type ResponseType = { grouped_categories: TemplateCategoriesType }

export const useGetTemplateCategories = () => {
  const getTemplateCategories = async () => {
    const response = await baseClient.get<ResponseType>('templates/categories')
    return response.data
  }

  return useQuery({
    queryKey: ['templateCategories'],
    queryFn: () => getTemplateCategories(),
  })
}
